export default __webpack_public_path__ + "static/media/Image.f42b81de.svg";